import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import {
  authStore,
  uiStore,
  recipeStore,
  wagesStore,
  salesStore,
  tillsStore,
  supplierStore,
  invoiceStore,
  expenseStore,
  payStore,
  employesStore,
  inventoryStore,
  taxesStore,
  localisationStore,
  wasteCauseStore,
  preparationSlipStore,
  orderTemplateStore,
  deliverySlipStore,
  customerStore,
  searchStore,
  tagStore,
  analyticsStore,
  globalSupplierStore,
  helperStore,
  socketStore,
  historyStore
} from "./module";

Vue.use(Vuex);

const vuexPlugin = new VuexPersistence({
  storage: window.localStorage,
  modules: ["authStore", "uiStore", "analyticsStore", "historyStore"]
});

export default new Vuex.Store({
  modules: {
    authStore,
    uiStore,
    recipeStore,
    wagesStore,
    salesStore,
    tillsStore,
    supplierStore,
    invoiceStore,
    expenseStore,
    payStore,
    employesStore,
    inventoryStore,
    taxesStore,
    localisationStore,
    wasteCauseStore,
    preparationSlipStore,
    orderTemplateStore,
    deliverySlipStore,
    customerStore,
    searchStore,
    tagStore,
    analyticsStore,
    globalSupplierStore,
    helperStore,
    socketStore,
    historyStore
  },
  plugins: [vuexPlugin.plugin]
});
